export default class LocaleHelper {

  static get formLocale() {
    let url = new URL(window.location.href);
    return url.searchParams.get('form_locale') || 'en'
  }

  static get activeLanguage() {
    let language = this.supportedLanguages.find(lng => Object.keys(lng)[0] === this.formLocale);
    return language[this.formLocale];
  }

  static setFormLocale(lang) {
    let url = new URL(window.location.href);
    url.searchParams.set('form_locale', Object.keys(lang)[0]);
    window.location.href = url.href;
  }

  static get supportedLanguages() {
    return [
      { en: this.localeFullName('en') },
      { en_gb: this.localeFullName('en-GB') },
      { es: this.localeFullName('es') },
      { fr_ca: this.localeFullName('fr-CA') },
      { ja: this.localeFullName('ja') },
      { id_ID: this.localeFullName('id-ID') },
      { km_KH: this.localeFullName('km-KH') },
      { my_MM: this.localeFullName('my-MM') },
      { ms_MY: this.localeFullName('ms-MY') },
      { tl_PH: this.localeFullName('tl-PH') },
      { vi_VN: this.localeFullName('vi-VN') },
      { zh: this.localeFullName('zh') },
      { zh_hk: this.localeFullName('zh-HK') }
    ]
  }

  static get disabledByLocaleClass() {
    return 'disabled-by-locale'
  }

  static localeFullName(locale) {
    return this.localeFullNameMapping[locale];
  }

  static get localeFullNameMapping() {
    return {
      'en': 'English',
      'en-GB': 'English (UK)',
      'es': 'Spanish',
      'fr-CA': 'Français (Canada)',
      'ja': 'Japanese',
      'id-ID': 'Indonesian (Indonesia)',
      'km-KH': 'Khmer',
      'ms-MY': 'Malay',
      'my-MM': 'Burmese',
      'tl-PH': 'Tagalog',
      'vi-VN': 'Vietnamese',
      'zh': 'Chinese',
      'zh-HK': 'Chinese Traditional (Hong Kong)'
    }
  }

  static getNextLocale(locale) {
    if (locale.length === 2) {
      return locale;
    } else {
      const nextLocale = locale.replace('_', '-');
      return nextLocale;
    }
  }
}
